module.exports = require("@ember/array/proxy");